import { Box, Button } from '@mui/material'
import { Chat20Regular, Folder20Regular, Note24Regular } from '@/components/Icon'
import { useThreadStatusStore } from '@/store/threadStatusStore'
import styles from './ThreadListRow.module.scss'

export default function ThreadListRowTitleButton({
  title,
  thread,
  active,
  onClick,
  showNoteIcon,
  showChatIcon,
  showFolderIcon,
  LeadingIcon,
  density = 'default',
}) {
  const Icon = LeadingIcon ?? (showNoteIcon ? Note24Regular : showChatIcon ? Chat20Regular : showFolderIcon ? Folder20Regular : null)
  const hasLeadingIcon = Boolean(Icon)
  const isGenerating = useThreadStatusStore(state => thread ? state.generatingIds.has(thread.id) : false)
  const isUnread = useThreadStatusStore(state => thread ? state.unreadIds.has(thread.id) : false)
  const showActiveStatus = isGenerating || isUnread

  return (
    <Button
      type="button"
      variant="text"
      onClick={onClick}
      aria-current={active ? 'true' : undefined}
      className={`${styles.threadRow} ${hasLeadingIcon ? styles.threadRowWithLeadingIcon : ''} ${density === 'compact' ? styles.threadRowCompact : ''}`}
    >
      <Box
        component="span"
        className={`${styles.statusCircle} ${showActiveStatus ? styles.statusCircleActive : styles.statusCircleNormal}`}
        aria-hidden
      />
      {Icon ? (
        <Box component="span" className={`${styles.leadingIcon} ${density === 'compact' ? styles.leadingIconCompact : ''}`} aria-hidden>
          <Icon />
        </Box>
      ) : null}
      <Box component="span" className={`${styles.title} ${density === 'compact' ? styles.titleCompact : ''}`}>
        {title}
      </Box>
    </Button>
  )
}
